export default {
  "opportunities": [
    {
      "id": 1,
      "name": "Investment Header Goes Here",
      "sectorId": 1,
      "regionId": 14,
      "center": [
        -77.0428,
        -12.0464
      ],
      "shore_coord": [
        -75.4742,
        -14.9755
      ],
      "chart_data": [
        4,
        1,
        3,
        5,
        4,
        2
      ]
    },
    {
      "id": 2,
      "name": "Lima Internatiol Conference & Exhibition Centre",
      "sectorId": 29,
      "regionId": 5,
      "center": [
        -83.6159,
        -9.5101
      ],
      "shore_coord": [
        -78.5745,
        -9.0665
      ],
      "chart_data": [
        2,
        1,
        3,
        5,
        4,
        2
      ]
    },
    {
      "id": 3,
      "name": "Opportunity 3",
      "sectorId": 30,
      "regionId": 8,
      "center": [
        -80.5186,
        -16.8151
      ],
      "shore_coord": [
        -75.4742,
        -14.9755
      ],
      "chart_data": [
        2,
        1,
        3,
        5,
        4,
        2
      ]
    },
    {
      "id": 4,
      "name": "Opportunity 4",
      "sectorId": 1,
      "regionId": 7,
      "center": [
        -71.9675,
        -13.532
      ],
      "shore_coord": [
        -75.4742,
        -14.9755
      ],
      "chart_data": [
        2,
        1,
        3,
        5,
        4,
        2
      ]
    },
    {
      "id": 5,
      "name": "Opportunity 5",
      "sectorId": 1,
      "regionId": 10,
      "center": [
        -75.7342,
        -14.0755
      ],
      "shore_coord": [
        -75.4742,
        -14.9755
      ],
      "chart_data": [
        2,
        1,
        3,
        5,
        4,
        2
      ]
    },
    {
      "id": 6,
      "name": "Opportunity Oil & Gas",
      "sectorId": 29,
      "regionId": 17,
      "center": [
        -77.5186,
        -14.8151
      ],
      "shore_coord": [
        -76.1155,
        -14.2616
      ],
      "chart_data": [
        2,
        1,
        3,
        5,
        4,
        2
      ]
    },
    {
      "id": 7,
      "name": "Oil & Gas project",
      "sectorId": 30,
      "regionId": 1,
      "center": [
        -76.5186,
        -16.8151
      ],
      "shore_coord": [
        -74.3209,
        -15.8297
      ],
      "chart_data": [
        2,
        1,
        3,
        5,
        4,
        2
      ]
    }
  ]
}